import React, { useEffect } from "react";
import styled from "styled-components";
import { Container } from "../../../Components/StyledComponents/StyledComponents";
import NftMarketHomepage from "../NftMarketPage/NftMarketHomepage";
import MyNftsHomepage from "./MyNftsHomepage";
import { useNavigate } from "react-router";

const Root = styled.div``;

const MyNfts = (props) => {
  const navigate = useNavigate(null);

  useEffect(() => {
    if (!props.allContractDetails) {
      navigate("/nftMarket");
    }
  }, [props.allContractDetails]);
  return (
    <Root>
      <Container>
        <NftMarketHomepage {...props} />
        <MyNftsHomepage {...props} />
      </Container>
    </Root>
  );
};

export default MyNfts;
